'use client'

import clsx from 'clsx'
import { ButtonHTMLAttributes, useCallback, useEffect } from 'react'
import { useSwiper } from 'swiper/react'

import cl from './SlideButtons.module.scss'

type SlidePrevButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	className?: string
}

export const SliderPrevButton = (props: SlidePrevButtonProps) => {
	const { className, disabled, onClick, type = 'button', ...restProps } = props

	const swiper = useSwiper()

	const handleSwipeOnKeyDown = useCallback(
		(e: KeyboardEvent) => {
			if (!disabled && e.key === 'ArrowLeft') swiper?.slidePrev()
		},
		[disabled, swiper]
	)

	useEffect(() => {
		document.body.addEventListener('keydown', handleSwipeOnKeyDown)

		return () => {
			document.body.removeEventListener('keydown', handleSwipeOnKeyDown)
		}
	}, [handleSwipeOnKeyDown, swiper])

	return (
		<button
			type={type}
			disabled={disabled}
			onClick={onClick ?? (() => swiper.slidePrev())}
			className={clsx(cl.root, className)}
			aria-label="Перейти к предыдущему слайду"
			title="Предыдущий слайд"
			{...restProps}>
			<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
				<g id="arrow">
					<path
						id="Icon"
						d="M10.7071 13.7071C11.0976 13.3166 11.0976 12.6834 10.7071 12.2929L5.41421 7L10.7071 1.70711C11.0976 1.31658 11.0976 0.683417 10.7071 0.292893C10.3166 -0.0976315 9.68342 -0.0976315 9.29289 0.292893L3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071Z"
						fill="#545563"
					/>
				</g>
			</svg>
		</button>
	)
}
